// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"d25e7b8f","331":"2dee05a6","612":"eabcdd25","820":"148c3941"}[chunkId] + ".chunk.css";
};